import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"




function ChokerSetsPage({ categoryType}) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default ChokerSetsPage